import { render, staticRenderFns } from "./StickersCarousel.vue?vue&type=template&id=d63bad5e"
import script from "./StickersCarousel.vue?vue&type=script&lang=js"
export * from "./StickersCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports